import React, { useState } from "react";
import { CardWithActions, LineDivider } from "@/components";
import { AppBar, Box } from "@mui/material";
import { TabbedNavigationWithBadges } from "@/components";

import PendingApprovals from "@/pages/attendance/views/approvals/PendingApprovals";
import ApprovedApprovals from "@/pages/attendance/views/approvals/ApprovedApprovals";
import { useGetApprovalsQuery } from "@/api/services/attendance/approvals/Approvals";



const Regularization = () => {
 
  const [tabIndex, setTabIndex] = useState(0);

  const { data: pendingData, refetch: PendingRefetch, isLoading: isLoadingPending } = useGetApprovalsQuery({ key: "Pending" });
  const { data: approvedData, refetch: ApprovedRefetch, isLoading: isLoadingApproved } = useGetApprovalsQuery({ key: "Approved" });

  // Compute records
  const pendingRecords = pendingData || [];
  const approvedRecords = approvedData || [];

  // Tabs with dynamic count
  const tabs = [
    { name: "Pending", count: pendingRecords?.data?.count, key: "Pending" },
    { name: "Completed", count: approvedRecords?.data?.count, key: "Approved" },
  ];

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const renderContent = (
    <Box sx={{ p: (theme) => theme.spacing(0, 0) }}>
      {tabIndex === 0 && (
        <>
          <LineDivider /> <PendingApprovals approvalsRecords={pendingRecords} PendingRefetch={PendingRefetch}
           ApprovedRefetch={ApprovedRefetch} isLoadingPending={isLoadingPending} />
        </>
      )}
      {tabIndex === 1 && (
        <>
          <LineDivider />
          <ApprovedApprovals approvalsRecords={approvedRecords} isLoadingApproved={isLoadingApproved}/>
        </>
      )}
    </Box>
  );

  return (
    <CardWithActions headerTitle="Approvals" headerActions={[]}>
      <TabbedNavigationWithBadges
        tabs={tabs}
        value={tabIndex}
        onChange={handleTabChange}
        renderContent={renderContent}
      />{" "}
    </CardWithActions>
  );
};

export default Regularization;
